const blockTypes = {
    AUDIO: "audio",
    SPEAKER: "speaker",
    VIDEO: "video"
};

export default blockTypes;
